import { bool, string } from "prop-types";

import styled from "styled-components/macro";
import { themeSizes } from "theme";

import FnrContainedIcon from "UI/FnrContainedIcon";
import { marketingColors } from "UI/colors";

import { VERIFICATION_PROVIDER } from "../hooks/useAddressAutocomplete";

AddressVerifiedCheck.propTypes = {
  isVerified: bool,
  verificationProvider: string,
  size: string,
  noPadding: bool,
  className: string,
};

/**
 * The verified-address checkmark, tooltipped with which verdict it stands for:
 * only a Smarty judgment is "USPS Verified", and every other verdict is an
 * admin's manual override reading "Admin Verified". Renders nothing without a
 * verdict, so callers hand it the metadata and skip the guard.
 *
 * Placement belongs to the caller — the board cell pins it to a cell corner,
 * the change log sets it beside the after-value — via styled(AddressVerifiedCheck).
 */
export default function AddressVerifiedCheck({
  isVerified,
  verificationProvider,
  size = themeSizes.lg,
  noPadding,
  className,
}) {
  if (!isVerified) return null;

  return (
    <Check
      className={className}
      title={
        verificationProvider === VERIFICATION_PROVIDER
          ? "USPS Verified"
          : "Admin Verified"
      }
    >
      <FnrContainedIcon
        icon="check-circle fas"
        size={size}
        color={marketingColors.blue}
        noBackgroundColor
        noPadding={noPadding}
      />
    </Check>
  );
}

const Check = styled.span`
  display: inline-flex;
  line-height: 0;
`;
